import { render, staticRenderFns } from "./BsPanel.vue?vue&type=template&id=8c987f7a&lang=html&"
import script from "./BsPanel.vue?vue&type=script&lang=js&"
export * from "./BsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports